import CartOverview, { CartOverviewProps } from './CartOverview';

export type { CartOverviewProps };
export default CartOverview;
